import { createSelector } from 'reselect'

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getId = (state, props) => {
  return props.cardContext.id
}

export const getName = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].name
}

export const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

const createIsObservedSelector = () => createSelector(
  [
    (_, { cardContext }) => cardContext.id,
    state => state.kanbo.observedTags,
  ],
  (
    cardId,
    observedTags,
  ) =>
    observedTags.some(tag => tag === `card-${cardId}`)
)

export default () => createSelector(
  [
    getIsArchived,
    getId,
    getName,
    getIsTemplate,
    createIsObservedSelector(),
  ],
  (
    isArchived,
    id,
    name,
    isTemplate,
    isObserved,
  ) => ({
    isArchived,
    id,
    name,
    isTemplate,
    isObserved,
  })
)
